<template>
  <div class="toast shadow-md" :class="type" @click.stop.prevent="hideToast">
    <div class="flex w-full max-w-sm mx-auto bg-white">
      <div class="flex items-center justify-center w-12 toast-side">
        <svg
          class="w-6 h-6 text-white fill-current"
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 3.36667C10.8167 3.36667 3.3667 10.8167 3.3667 20C3.3667 29.1833 10.8167 36.6333 20 36.6333C29.1834 36.6333 36.6334 29.1833 36.6334 20C36.6334 10.8167 29.1834 3.36667 20 3.36667ZM19.1334 33.3333V22.9H13.3334L21.6667 6.66667V17.1H27.25L19.1334 33.3333Z"
          />
        </svg>
      </div>

      <div class="px-4 py-2 pb-5 -mx-3">
        <div class="mx-3">
          <span v-if="type !== 'info'" class="font-semibold toast-text"
            >Error</span
          >
          <p class="text-sm mt-3">
            <slot />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.toast {
  position: fixed;
  top: calc(50% - 45px);
  left: calc(50% - 200px);
  width: 400px;
  max-width: 80%;
  border: 1px solid #ce4200;
  border-radius: 0.5rem;
  overflow: hidden;
  z-index: 99999;
}

.toast-side {
  background: #ce4200;
}

.toast-text {
  color: #ce4200;
}

.toast.info {
  border: 1px solid #00810e;
}

.info .toast-side {
  background: #00810e;
}

.info .toast-text {
  color: #00810e;
}
</style>

<script setup>
// Props
const props = defineProps({
  type: String,
});

// Emit
const emit = defineEmits(["hideToast"]);

// Methods
const hideToast = () => {
  emit("hideToast");
};
</script>
